/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/story/storytitle/storytitle_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});

/* ========== ~~~~~~~~~~ QUESTION SET ~~~~~~~~~~ ========== */
const StoryTitle = props => (
            <div id={props.id} className={`${sheet.classes.storytitle}`}>
                <h1 onClick={() => props.handleClick('title')}  className={`titletext`}>{props.title}</h1>
            </div>
        );



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default StoryTitle;